module.exports = __webpack_public_path__ + "static/media/trend-portfolio bg.c6528537.png";